import React from 'react';
import Icon from './Icon';
import Link from './Link';

interface PoweredByProps {
  url: string;
  text?: string;
}

const PoweredBy = function ({
  url,
  text = 'Powered by Guuru',
}: PoweredByProps) {
  return (
    <Link
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      aria-label="Visit Guuru website"
    >
      <Icon aria-hidden="true" />
      <span>{text}</span>
    </Link>
  );
};

export default PoweredBy;
